/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import type { IProdutos, IProdutosResponse } from "@/hooks/produtos/buscar-produtos";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetProdutos } from "@/domain/use-cases/produtos";

/** Máximo de itens por página aceito pela API (`per_page`). */
const QUANTIDADE_MAXIMA_PRODUTOS = 100;

const PRODUTOS_VAZIOS: IProdutos[] = [];

/**
 * Produtos ativos para preencher selects (créditos, modelos técnicos).
 *
 * Não usa o store da listagem de produtos: a página, a quantidade por página e a
 * busca daquela tela não podem limitar as opções do select.
 */
function useListarProdutosAtivosSelecao() {
  const { token: accessToken } = useStoreZustandUserAuth();

  const {
    error: isErrorProdutos,
    data: produtosResponse,
    isLoading: isLoadingProdutos,
  } = useQuery<IProdutosResponse>({
    // Prefixo "produtos": invalidar ["produtos"] também atualiza o select
    queryKey: ["produtos", "ativos-selecao"],
    queryFn: async () => {
      const response = await handleGetProdutos(
        accessToken!,
        1,
        QUANTIDADE_MAXIMA_PRODUTOS,
        "",
        true
      );

      return response;
    },
  });

  const produtos = produtosResponse?.data ?? PRODUTOS_VAZIOS;

  return {
    produtos,
    isLoadingProdutos,
    isErrorProdutos,
  };
}

/**
 * EXPORTS
 */
export { useListarProdutosAtivosSelecao };
